import { rgba } from "polished";

import { CenterContent, Icon } from "shared/styles";
import { SubscriptionSummary } from "Bands/pages/subscription/containers";
import { copy } from "shared/assets";
import { Spacer } from "shared/layout";
import { Button, Title } from "shared/components";
import { getStatus } from "shared/styles/defaults";
import { IStatus } from "shared/types";
import { BAND_PATHS } from "Bands/router";
import { useCompanyRoute } from "Bands/utils";
import { useSubscriptionContext } from "Bands/contexts";

const confirmationCopy = copy.subscription.confirmation;

export const SubscriptionSuccess = () => {
  const { selectedSubscription, selectedBilling } = useSubscriptionContext();

  const { icon, iconColor } = getStatus(IStatus.success);
  const { pushRoute: pushCompanyRoute } = useCompanyRoute();

  if (!selectedSubscription || !selectedBilling) {
    return null;
    // todo redirect
  }

  return (
    <CenterContent>
      <Spacer size="xl" align="center">
        <Icon
          isCircle
          backgroundColor={rgba(iconColor as string, 0.25)}
          as={icon}
          height="60px"
          width="60px"
          color={iconColor}
          padding="18px"
        />
        <Title asComponent="h2">{confirmationCopy.title}</Title>
        <span>{confirmationCopy.subtitle}</span>
        <SubscriptionSummary />
        <Button
          onClick={() =>
            pushCompanyRoute(BAND_PATHS.COMPANY_DASHBOARD, {
              companyId: selectedBilling?.id,
            })
          }
        >
          {confirmationCopy.dashboard}
        </Button>
      </Spacer>
    </CenterContent>
  );
};
